import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CardContainer, CardInfo, CardTitle } from './rectangleCardComponent.style'

export const RectangleCardComponent = ({
                                           title, description, quickLinks, image,
                                           onClick,
    data,
                                           handleClick
                                       }) => {

    const navigate = useNavigate();

    const handleCardClick = () => {
        if (handleClick) {
            handleClick();
        } else if (onClick) {
            onClick();
        }
    };

    return (
        <CardContainer id={title} onClick={handleCardClick}>
            {image}
            <CardInfo id={title + '--info'}>
                <div>
                    <CardTitle>{title || data?.name}</CardTitle>
                    <p id={'description'}>{description || data?.description}</p>
                </div>
                {quickLinks}
            </CardInfo>
        </CardContainer>
    )
}
